import React, { useState, useEffect } from 'react';
import { ArrowRight, Star, Film, Award, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const defaultCards = [
  {
    icon: Star,
    title: "Honoring Leonard",
    description: "Celebrating his remarkable life and the values of hope, logic, and compassion he shared with the world.",
    link: "/remembering-leonard"
  },
  {
    icon: Film,
    title: "The Documentary",
    description: "Watch the powerful documentary about Leonard Nimoy's extraordinary life and lasting legacy.",
    link: "/film"
  },
  {
    icon: Award,
    title: "LLAP Tribute Award",
    description: "Honoring individuals and organizations that embody the spirit of 'Live Long and Prosper.'",
    link: "/llap-tribute"
  },
  {
    icon: Calendar,
    title: "The Anniversary",
    description: "Join us every February 27th to honor Leonard's memory and celebrate his enduring message of hope.",
    link: "/anniversary"
  }
];

const WhatWeDoSection = () => {
  const [cards, setCards] = useState(defaultCards);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/homepage-content`);
        const content = response.data;
        if (content) {
          setCards([
            {
              icon: Star,
              title: content.card1_title || defaultCards[0].title,
              description: content.card1_description || defaultCards[0].description,
              link: content.card1_link || defaultCards[0].link
            },
            {
              icon: Film,
              title: content.card2_title || defaultCards[1].title,
              description: content.card2_description || defaultCards[1].description,
              link: content.card2_link || defaultCards[1].link
            },
            {
              icon: Award,
              title: content.card3_title || defaultCards[2].title,
              description: content.card3_description || defaultCards[2].description,
              link: content.card3_link || defaultCards[2].link
            },
            {
              icon: Calendar,
              title: content.card4_title || defaultCards[3].title,
              description: content.card4_description || defaultCards[3].description,
              link: content.card4_link || defaultCards[3].link
            }
          ]);
        }
      } catch (err) {
        console.log('Using default cards');
      }
    };
    fetchContent();
  }, []);

  return (
    <section className="py-24 bg-[#0a0a0b]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            What We Do
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Honoring Leonard Nimoy's memory through education, recognition, and community.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, index) => (
            <Link
              key={index}
              to={card.link}
              className="group bg-[#141416] border border-gray-800/50 rounded-2xl p-6 hover:border-amber-500/50 transition-all duration-300"
            >
              <div className="w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-amber-500/20 transition-colors">
                <card.icon className="w-6 h-6 text-amber-500" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-amber-500 transition-colors">
                {card.title}
              </h3>
              <p className="text-gray-400 text-sm mb-4">
                {card.description}
              </p>
              <div className="flex items-center text-amber-500 text-sm font-medium">
                Learn more
                <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoSection;
